module.exports = __webpack_public_path__ + "static/media/DepressionActive.9493c258.svg";